import { render } from "./LandingPartner.vue?vue&type=template&id=a3604b7a&scoped=true"
import script from "./LandingPartner.vue?vue&type=script&lang=js"
export * from "./LandingPartner.vue?vue&type=script&lang=js"

import "./LandingPartner.vue?vue&type=style&index=0&id=a3604b7a&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3604b7a"]])

export default __exports__